import { defineStore } from 'pinia';
import { computed } from 'vue';
import { useStore } from 'vuex';

import { useCart } from '@/composables/useCart';
import { CartDiscountMaybeStandardFields, getCartDiscountsForMessages } from '@/lib/cart/discounts';

export const useCartDiscounts = defineStore('cartDiscounts', () => {
  const store = useStore();
  const { cart } = useCart(store);

  const currentAppliedCodeDiscounts = computed<CartDiscountMaybeStandardFields[]>(() =>
    getCartDiscountsForMessages(cart.value, { mustMatchCart: true }),
  );

  const cartConditionsMetMessage = computed(
    () =>
      currentAppliedCodeDiscounts.value.find((d) => d.custom?.fields.cartConditionsMetMessage)
        ?.custom?.fields.cartConditionsMetMessage,
  );

  return {
    cartConditionsMetMessage,
    currentAppliedCodeDiscounts,
  };
});
